exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vslimg{width:calc(100% - 40px);margin:20px;height:400px;image-rendering:pixelated;vertical-align:middle;object-fit:cover;object-position:50% 50%}.vslimgcont:after{content:\"No Photo\";display:block;position:absolute;font-size:3rem;top:36%;left:50%;z-index:100;color:#636363;transform:translate(-50%,-50%);opacity:.5}@media (max-width:768px){.vslimg{margin:0!important;width:100%;height:200px}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fade-in-animation{animation:fadeIn .5s ease-in-out forwards}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/PhpstormProjects/e-crewing/~/css-loader?minimize!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/style-rewriter.js?id=data-v-521ca2cf!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/selector.js?type=styles&index=0!./vue/fleet/components/Images.vue
// module id = 118
// module chunks = 3